import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { GridDesktop } from "./desktop";
import { GridMobile } from "./mobile";

export const Grid = () => {
  return <ResponsiveBlockSwitcher desktop={<GridDesktop />} mobile={<GridMobile />} />;
};
